import styled from "styled-components";
import { media } from "../../theme/breakpoints";

export const LogoWrapper = styled.div`
    margin-top: 3%;
    margin-bottom: 4%;

    img {
        width: 320px;
        height: auto;
    }
`;

export const AuthContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    background-color: #f9f9f9;
    padding: 16px;

    ${media.sm} {
        padding: 24px;
    }

    ${media.md} {
        padding: 36px;
    }
`;
